import React from 'react';

import {BulkActionTool} from 'src/components/bulk-tool';
import {
    bulkAssignAccountsEntitlements,
    getAssignAccountsEntitlementsProgress,
    stopBulkActions,
} from 'src/openapi/admin/apis/BulkAssignAccountsEntitlementsApi';
import {useAppDispatch} from 'src/store/hooks';

import {UpdateAccountsEntitlementsModal} from '../update-accounts-entitlements.modal';

import {
    selectAssignAccountsEntitlementsBulkUuid,
    selectAssignAccountsEntitlementsTask,
    setBackgroundTask,
    setShown,
    setUuid,
} from './assign-accounts-entitlements.slice';
import {
    TOOL_PROGRESS_LABEL,
    TOOL_STACK_OVERFLOW_MESSAGE,
    TOOL_TASK,
    TOOL_TITLE,
} from './constants';

import type {UpdateEntitiesEntitlementsRelation} from 'src/openapi/admin/models/UpdateEntitiesEntitlementsRelation';

type Props = {
    ids: string[],
    shown: boolean,
    onClose: () => void,
};

export const AssignAccountsEntitlementsTool = ({ids, shown, onClose}: Props) => {
    const apiDispatch = useAppDispatch();

    return (
        <BulkActionTool<UpdateEntitiesEntitlementsRelation>
            shown={shown}
            onClose={onClose}
            width={800}

            toolTask={TOOL_TASK}
            toolName={TOOL_TITLE}
            progressLabel={TOOL_PROGRESS_LABEL}

            taskSelector={selectAssignAccountsEntitlementsTask}
            uuidSelector={selectAssignAccountsEntitlementsBulkUuid}

            setUuid={setUuid}
            setTask={setBackgroundTask}
            setResultShown={setShown}
            saveActionRequest={(updateEntitiesEntitlementsRelation, options) => (
                apiDispatch(bulkAssignAccountsEntitlements({...options, updateEntitiesEntitlementsRelation}))
            )}
            getProgress={id => apiDispatch(getAssignAccountsEntitlementsProgress({id}))}
            stopAction={id => apiDispatch(stopBulkActions({id}))}

            stackOverflowMessage={TOOL_STACK_OVERFLOW_MESSAGE}
            onDone={() => undefined}>
            {({processAction, onCloseModal}) => (
                <UpdateAccountsEntitlementsModal
                    ids={ids}
                    mode="ASSIGN"
                    onCloseModal={onCloseModal}
                    processAction={processAction}
                />
            )}
        </BulkActionTool>
    );
};
